import React from 'react'

const SidebarToggleIcon = (): JSX.Element => (
  <svg className='sidebar-toggle-icon' viewBox='0 0 24 24'>
    <rect className='sidebar-toggle-container' x='4' y='6' width='16' height='12' rx='2'/>
    <line className='sidebar-toggle-divider' x1='10.4' y1='6' x2='10.4' y2='18'/>
  </svg>
)

export default SidebarToggleIcon
